import React from 'react'
import { connect } from 'react-redux'
import { getListFromValues } from '../../public/utility'
import { hasChangedValues } from '../../public/utility/formValues'
import StandardInspectionMethodDiv from './StandardInspectionMethodDiv'

const s = { margin: '5px 5px 5px 5px', minWidth: 200, flex: 10 }

class StandardInspectionDiv extends React.Component {
    state = {
        id: this.props.id,
        JudgeStandardID: this.props.JudgeStandardID,
        processing: 0,//限制并发操作
        onlyView: this.props.onlyView,
    }
    componentDidMount = () => {
        this.handlerGetStandardInspection()
    }

    handlerGetStandardInspection = () => {
        const { onClose } = this.props
        const { id, JudgeStandardID } = this.state
        Tyan.doPostEvent({
            event: 'GetStandardInspection',
            data: { id, JudgeStandardID },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    onClose && onClose()
                }
                else {
                    this.setState({ id, optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
                setTimeout(this.handelFinish, 100)
            }
        })
    }

    handelBegin = () => this.setState((state) => ({ processing: state.processing + 1 }))
    handelFinish = () => this.setState((state) => ({ processing: state.processing - 1 }))

    handlerConfirm = () => {
        const { initValues基本信息, changedValues基本信息, id, JudgeStandardID } = this.state
        const { onSave, onClose } = this.props
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        if (!values.项目名称 || values.项目名称.trim() == '') { Ext.toast("项目名称不能为空！"); return }

        Tyan.doPostEvent({
            event: 'SaveStandardInspection',
            data: { id, JudgeStandardID, changedValues基本信息 },
            onRequest: this.handelBegin,
            onEnd: ({ errorMessage }) => {
                setTimeout(this.handelFinish, 100)
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DelStandardInspection',
                data: { id },
                onRequest: this.handelBegin,
                onEnd: ({ errorMessage }) => {
                    setTimeout(this.handelFinish, 100)
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerAddMethod = () => {
        const { id, onlyView } = this.state
        if (id <= 0) {
            const { initValues基本信息, changedValues基本信息, id, JudgeStandardID } = this.state
            const values = { ...initValues基本信息, ...changedValues基本信息 }
            if (!values.项目名称 || values.项目名称.trim() == '') { Ext.toast("项目名称不能为空！"); return }

            Tyan.doPostEvent({
                event: 'SaveStandardInspection',
                data: { id, JudgeStandardID, changedValues基本信息 },
                onRequest: this.handelBegin,
                onEnd: ({ errorMessage, id }) => {
                    setTimeout(this.handelFinish, 100)
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('保存成功')
                        this.setState({ id })
                        Tyan.pubForm.showDialog('检测方法', props => <StandardInspectionMethodDiv {...props} id={-1} StandardInspectionID={id} onlyView={onlyView} onSave={this.handlerGetStandardInspection} />)
                    }
                }
            })
        }
        else {
            Tyan.pubForm.showDialog('检测方法', props => <StandardInspectionMethodDiv {...props} id={-1} StandardInspectionID={id} onlyView={onlyView} onSave={this.handlerGetStandardInspection} />)
        }
    }

    handlerEditMethod = (methodID) => {
        const { onlyView } = this.state
        Tyan.pubForm.showDialog('检测方法', props => <StandardInspectionMethodDiv {...props} id={methodID} onlyView={onlyView} onSave={this.handlerGetStandardInspection} />)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => {
            onClose && onClose()
        })
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息, onlyView } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }

        var _fieldset = []
        const obj检测方法 = getListFromValues('检测方法', values['检测方法'], initValues基本信息, changedValues基本信息)
        obj检测方法.list.forEach((o, iNo) => {
            const _list = { listName: '检测方法', id: o.id }
            _fieldset.push({
                _group: '', name: 'details', margin: '5 0 5 0', minWidth: '90%', items: [
                    { _text: '', name: '名称', list: _list, disabled: true, ...s },
                    {
                        _buttons: [
                            { _button: '详情', ui: 'action', margin: 0, handler: () => this.handlerEditMethod(o.id), cdt: () => !onlyView }
                        ], width: '101px', margin: '0 0 0 10'
                    },
                ]
            })
        })
        _fieldset.push(
            {
                _group: '', minWidth: '90%', margin: 0, padding: '0 10 0 0', items: [
                    { _label: '', margin: 0, minWidth: '70%' },
                    {
                        _buttons: [
                            { _button: '添加...', ui: '', margin: '0px 15px 0px 0px', handler: this.handlerAddMethod, cdt: () => !onlyView },
                        ], width: null, margin: 0
                    }
                ]
            }
        )
        return [
            { _text: '项目名称', required: true, minWidth: '90%' },
            { _text: '项目显示名称', name: '显示名称', minWidth: '90%' },
            { _text: '英文项目名称', name: '英文名称', minWidth: '90%' },
            { _checkbox: '前处理', items: ['不需要'], minWidth: '90%' },
            {
                _border: '检测方法', margin: '5 0 5 0', minWidth: '90%', items: _fieldset
            },
            { _int: '排序', minWidth: '90%', textAlign: 'left' },
        ]
    }

    canSave = () => {
        const { changedValues基本信息 } = this.state
        return Object.keys(changedValues基本信息).length > 0
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息, onlyView } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        return <Body data={this} maxWidth="800"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerConfirm, cdt: () => !onlyView },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && !onlyView, handler: this.handlerDelete },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: onlyView },
                ]}
        />
    }
}

export default connect()(StandardInspectionDiv)